import React from "react";
import { NavLink } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import { FaEnvelope } from "react-icons/fa";

const Footer = () => {
  const footerLink = {
    company: [
      "About us",
      "New & Blog",
      "Our Team",
      "Converter",
      "Exchange Rate",
    ],
    resource: [
      "Contact us",
      "FAQ",
      "Download App",
      "Privacy Policy",
      "Term & Conditions",
    ],
    transfer: [
      "Register / Login",
      "Currency Chart",
      "USA Money Transfer",
      "India Money Transfer",
      "UK Money Transfer",
    ],
  };

  const detail = [
    {
      icon: <IoLocationSharp />,
      title: "Location",
      content: "2767 Sunrise Street, NY 1002, USA",
    },
    { icon: <FaEnvelope />, title: "Email", content: "hello@gmail.com" },
    { icon: <FaPhoneAlt />, title: "Phone", content: "+1-3454-5678-77" },
  ];

  return (
    <>
      <footer className="padding-top padding-bottom">
        <div className="container px-sm-1 px-4 ">
          <div className="row d-flex ">
            <div className="col-xl-3 col-lg-4 mb-xl-1 mb-5  pe-md-5" data-aos='zoom-in'>
              <div className="footer_section">
                <img src="/image/logo.png" className="img-fluid" alt="" />
                <div className="footer_content mt-4">
                  <p className="text-justify-left text-color">
                    Lorem ipsum dolor sit amet consc tetur adicing elit. Dolor
                    emque dicta molest enim beatae ame consequ atur tempo
                    pretium auctor nam.
                  </p>
                  <div className="footer_icon mt-4 d-flex gap-3">
                    <i className="fa fa-facebook"></i>
                    <i className="fa fa-twitter"></i>
                    <i className="fa fa-instagram"></i>
                    <i className="fa fa-linkedin"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-2 col-lg-4 mb-xl-1 mb-5 col-6 " data-aos='fade-up'>
              <div className="footer_section">
                <h5 className="text-white fw-800 transition pb-3 position-relative">
                  Company
                </h5>
                <div className="footer_line">
                  <div className="footer_line_inner"></div>
                </div>
                <div className="footer_content mt-4">
                  <ul className="list-unstyled footer_link">
                    {footerLink.company.map((element, index) => {
                      return (
                        <li key={index} className="mb-3">
                          <NavLink className="link" to="/">
                            {element}
                          </NavLink>{" "}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            <div data-aos='fade-up' className="col-xl-2 col-lg-4 mb-xl-1 mb-5 col-6">
              <div className="footer_section">
                <h5 className="text-white fw-800 transition pb-3 position-relative">
                  Resources
                </h5>
                <div className="footer_line">
                  <div className="footer_line_inner"></div>
                </div>
                <div className="footer_content mt-4">
                  <ul className="list-unstyled footer_link">
                    {footerLink.resource.map((element, index) => {
                      return (
                        <li key={index} className="mb-3">
                          <NavLink className="link" to="/">
                            {element}
                          </NavLink>{" "}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            <div data-aos='fade-up' className="col-xl-2 col-lg-4 mb-xl-1 mb-5 ">
              <div className="footer_section">
                <h5 className="text-white fw-800 transition pb-3 position-relative">
                  Transfer Money
                </h5>
                <div className="footer_line">
                  <div className="footer_line_inner"></div>
                </div>
                <div className="footer_content mt-4">
                  <ul className="list-unstyled footer_link">
                    {footerLink.transfer.map((element, index) => {
                      return (
                        <li key={index} className="mb-3">
                          <NavLink className="link" to="/">
                            {element}
                          </NavLink>{" "}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4" data-aos='zoom-in'>
              <div className="footer_section">
                <h5 className="text-white fw-800 transition pb-3 position-relative">
                  Contact Us
                </h5>
                <div className="footer_line">
                  <div className="footer_line_inner"></div>
                </div>
                <div className="footer_content mt-4">
                  {detail.map((element, index) => {
                    return (
                      <div key={index} className="d-flex mb-4">
                        <p className="mb-0 me-3 text-green">{element.icon}</p>
                        <div>
                          <h5 className="text-white fw-6">{element.title}</h5>
                          <p className="mb-0 text-color">{element.content}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* SUBFOOTER SECTION */}
      <div className="sub_footer">
        <div className="container py-3  border-top">
          <p className="mb-0 text-white text-center"> &copy; Cuex. All Rights Reserved By <a href="https://adnandev.netlify.app/" target="_blank"  className="text-decoration-none text-green">Adnan Tariq</a> </p>
        </div>
        </div>            

    </>
  );
};

export default Footer;
